import { render, staticRenderFns } from "./european-union-icon.vue?vue&type=template&id=428119bf"
import script from "./european-union-icon.vue?vue&type=script&lang=js"
export * from "./european-union-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports